import { useEffect, useRef } from 'react';
import { HorizontallyScrollable } from '@/components/HorizontallyScrollable';
import { SelectableButton } from '@/components/SelectableButton';

// Row of pill buttons that scrolls sideways once it stops fitting. The selected
// one is scrolled into view on mount, so a selection restored from the URL is
// not left off-screen.
export function SelectableButtonBar({ options, fadeColor }) {
  const selectedRef = useRef(null);
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    if (selectedRef.current && scrollContainerRef.current) {
      selectedRef.current.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }
  }, []);

  return (
    <HorizontallyScrollable ref={scrollContainerRef} fadeColor={fadeColor}>
      {options.map((option) => (
        <SelectableButton
          key={option.key}
          ref={option.selected ? selectedRef : null}
          onClick={option.onClick}
          selected={option.selected}          
        >
          {option.label}
        </SelectableButton>
      ))}
    </HorizontallyScrollable>
  );
}
